import { createFeatureSelector, createSelector } from '@ngrx/store';
import { IState, clubAdapter, clubFeatureKey } from './club.reducers';
import { createQueryParamsWithPagination } from '../../../shared/utils';
import { IClubFilter } from './club.interface';

const selectFeature = createFeatureSelector<IState>(clubFeatureKey);

const { selectAll, selectEntities } = clubAdapter.getSelectors(selectFeature);

// ── Entity ──

const selectError = createSelector(selectFeature, (state) => state.error);

const selectLoading = createSelector(selectFeature, (state) => state.loading);

const selectClubFilter = createSelector(selectFeature, (state) => state.filter);

const selectClubFilterRequest = createSelector(selectClubFilter, (state) =>
	createQueryParamsWithPagination<IClubFilter>(state),
);

// ── Socket ──

const selectSocketConnected = createSelector(
	selectFeature,
	(state) => state.socketConnected,
);

export const ClubSelectors = {
	selectAll,
	selectEntities,
	selectError,
	selectLoading,
	selectClubFilter,
	selectClubFilterRequest,
	selectSocketConnected,
};
